import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Scroll component that scrolls to top when we are navigating
// Code from: https://reacttraining.com/react-router/web/guides/scroll-restoration
const ScrollToTop: React.FunctionComponent = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
